<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sigilnotintoc sigil_not_in_toc" id="pgepubid00011"><a class="calibre2" id="CONTENTS"></a>CONTENTS</h2>
<p class="calibre3"><a href="#/Text/Section0003_split_000#TALES_OF_ADVENTURE">TALES OF ADVENTURE</a><br class="calibre4"/>
<br class="calibre4"/>
<a href="#/Text/Section0003_split_000#I">I. <span class="smcap">Début of Bimbashi Joyce</span></a><br class="calibre4"/>
<a href="#/Text/Section0004#II">II. <span class="smcap">The Surgeon of Gaster Fell</span></a><br class="calibre4"/>
<span href="#/Text/Section0005#III" title="Link target outside of Sample">III. <span class="smcap">Borrowed Scenes</span></span><br class="calibre4"/>
<span href="#/Text/Section0006#IV" title="Link target outside of Sample">IV. <span class="smcap">The Man from Archangel</span></span><br class="calibre4"/>
<span href="#/Text/Section0007#V" title="Link target outside of Sample">V. <span class="smcap">The Great Brown-Pericord Motor</span></span><br class="calibre4"/>
<span href="#/Text/Section0008_split_000#VI" title="Link target outside of Sample">VI. <span class="smcap">The Sealed Room</span></span><br class="calibre4"/>
<br class="calibre4"/>
<span href="#/Text/Section0008_split_001#TALES_OF_MEDICAL_LIFE" title="Link target outside of Sample">TALES OF MEDICAL LIFE</span><br class="calibre4"/>
<br class="calibre4"/>
<span href="#/Text/Section0008_split_001#VII" title="Link target outside of Sample">VII. <span class="smcap">A Physiologist's Wife</span></span><br class="calibre4"/>
<span href="#/Text/Section0011#VIII" title="Link target outside of Sample">VIII. <span class="smcap">Behind the Times</span></span><br class="calibre4"/>
<span href="#/Text/Section0012#IX" title="Link target outside of Sample">IX. <span class="smcap">His First Operation</span></span><br class="calibre4"/>
<span href="#/Text/Section0013#X" title="Link target outside of Sample">X. <span class="smcap">The Third Generation</span></span><br class="calibre4"/>
<span href="#/Text/Section0014#XI" title="Link target outside of Sample">XI. <span class="smcap">The Curse of Eve</span></span><br class="calibre4"/>
<span href="#/Text/Section0015#XII" title="Link target outside of Sample">XII. <span class="smcap">A Medical Document</span></span><br class="calibre4"/>
<span href="#/Text/Section0016#XIII" title="Link target outside of Sample">XIII. <span class="smcap">The Surgeon Talks</span></span><br class="calibre4"/>
<span href="#/Text/Section0017#XIV" title="Link target outside of Sample">XIV. <span class="smcap">The Doctors of Hoyland</span></span><br class="calibre4"/>
<span href="#/Text/Section0019#XV" title="Link target outside of Sample">XV. <span class="smcap">Crabbe's Practice</span></span><br class="calibre4"/>
<br class="calibre4"/>
<br class="calibre4"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?280c97be